import Mobile from '../../../modules/mobile/v1/mobile'

$.fn.VideoBg = function() {
  let self = this
  self.mlmi_mobile = ($.mlmi != undefined && $.mlmi.mobile != undefined) ? $.mlmi.mobile : new Mobile()
  self.video_ratio = self.find('.page-section__bg-video__wrapper').eq(0).find('iframe').attr('height') / self.find('.page-section__bg-video__wrapper').eq(0).find('iframe').attr('width')
  self.desktop = self.find('.page-section__bg-video__wrapper.--desktop iframe');
  self.mobile = self.find('.page-section__bg-video__wrapper.--mobile iframe');

  $('.page-section__bg-video__wrapper').each(function() {
    if ($(this).find('video').length > 0) {
      $(this).addClass('--looped-video')
    }
  })

  self.device = false;

  if (self.find('.page-section__bg-video__wrapper').eq(1)) {
    self.video_ratio_mobile = self.find('.page-section__bg-video__wrapper').eq(1).find('iframe').attr('height') / self.find('.page-section__bg-video__wrapper').eq(1).find('iframe').attr('width')
  }

  var video_embed = '';

  return function() {
    $(window).on('resize load orientationchange', function() {

      var cover_width = self.outerHeight() / ($(window).width() * self.video_ratio) * 100;

      if (!self.mlmi_mobile.isMobile) {
        if (self.device != 'desktop') {
          self.desktop.attr('src', self.desktop.attr('data-src'));
          self.mobile.removeAttr('src');
          self.device = 'desktop';
        }
      } else {
        if (self.device != 'mobile') {
          self.mobile.attr('src', self.mobile.attr('data-src'));
          self.desktop.removeAttr('src');

          if (self.video_ratio_mobile && self.device != false) {
            cover_width = self.outerHeight() / ($(window).width() * self.video_ratio_mobile) * 100;
          }
          self.device = 'mobile';
        }
      }

      if (cover_width > 100) {
        self.find('.page-section__bg-video__wrapper').css('--cover-width', cover_width + '%');
      } else {
        self.find('.page-section__bg-video__wrapper').css('--cover-width', '100%');
      }
    })
    return self
  }()
}
